import React from "react";
import FamilyLogo from "../assets/family.png";

export default function Header() {
  return (
    <div className="h-auto md:h-32 bg-blue-primary flex flex-col md:flex-row md:justify-evenly items-center py-4 md:py-0">
      <a href="/flyer-generator" className="">
        <div className="px-4 mt-4">
          <img className="w-48 md:w-56" src={FamilyLogo} />
        </div>
      </a>
      <div className="px-4 py-6 md:py-0 text-white text-3xl md:text-4xl">
        OneTrust Marketing Flyer Generator
      </div>
    </div>
  );
}
